import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import SVG from 'react-inlinesvg';
import starIcon from '@lifesize/ux-assets/vectors/svgIcons/star.svg';
import starOutlineIcon from '@lifesize/ux-assets/vectors/svgIcons/star-outline.svg';
import actions from 'actions/FullScreenModal';
import ButtonComp from 'components/Button/Button';
import ModalInput from 'components/ModalInput/ModalInput';
import classes from './ContactForm.module.scss';

const messages = defineMessages({
  namePlaceholder: { id: 'components.contacts.createContact.namePlaceholder', defaultMessage: 'Name' },
  detailsPlaceholder: { id: 'components.contacts.createContact.detailsPlaceholder', defaultMessage: 'Calling Details' },
  required: { id: 'components.contacts.createContact.required', defaultMessage: 'Required' }
});

const validate = (values, props) => {
  const errors = {};
  if (!values.name || values.name.trim().length === 0) {
    errors.name = props.intl.formatMessage(messages.required);
  }

  if (!values.sipUri || values.sipUri.trim().length === 0) {
    errors.sipUri = props.intl.formatMessage(messages.required);
  }

  return errors;
};

const saveButton = (<FormattedMessage
  id="save"
  defaultMessage="Save"
/>);

const resetButton = (<FormattedMessage
  id="cancel"
  defaultMessage="Cancel"
/>);

class ContactForm extends React.PureComponent {
  render = () => {
    const {
      contact,
      handleCancel,
      handleSubmit,
      intl,
      invalid,
      isCreate,
      pristine,
      reset,
      saveContact
    } = this.props;

    return (
      <div className={classes.createContactContainer}>
        <form
          onSubmit={handleSubmit(saveContact)}
          className={classes.createContactForm}
        >
          <section>
            <Field
              autoFocus
              component={ModalInput}
              label={intl.formatMessage(messages.namePlaceholder)}
              maxlength={64}
              name="name"
              required
              type="text"
            />
            {(!contact.id || contact.isFavoritable) &&
              <label
                className={classes.checkboxContainer}
                data-testid="chkbox-favorite"
              >
                <Field
                  component="input"
                  id="createFavorite"
                  name="favorite"
                  type="checkbox"
                />
                <SVG src={starIcon} className={classes.checked} data-testid="starIcon" />
                <SVG src={starOutlineIcon} className={classes.unchecked} data-testid="starOutlineIcon" />
              </label>
            }
            <Field
              component={ModalInput}
              label={intl.formatMessage(messages.detailsPlaceholder)}
              maxlength={63}
              name="sipUri"
              required
              type="text"
            />
            <Field
              component="input"
              name="id"
              required={false}
              type="hidden"
            />
            <Field
              component="input"
              name="contactType"
              required={false}
              type="hidden"
            />
            <input
              className={classes.hiddenSubmit}
              id="submit-form"
              name="contactFormSubmit"
              type="submit"
            />
            <div className={classes.requiredDescription}>
              <FormattedMessage
                id="components.contacts.createContact.requiredDescription"
                defaultMessage="*Indicates required field"
              />
            </div>
          </section>
        </form>
        <div className={classes.buttonBar}>
          <ButtonComp
            className={classes.contactButton}
            kind="secondary"
            onClick={reset && handleCancel}
            dataAttrs={{ 'data-testid': 'cancel-btn' }}
          >
            {resetButton}
          </ButtonComp>
          <ButtonComp
            className={classes.contactButton}
            kind="primary"
            disabled={(pristine && !isCreate) || invalid}
            onClick={() => {
              document.getElementById('submit-form').click();
            }}
            dataAttrs={{ 'data-testid': 'save-btn' }}
          >
            {saveButton}
          </ButtonComp>
        </div>
      </div>
    );
  }
}

ContactForm.propTypes = {
  saveContact: PT.func,
  handleCancel: PT.func,
  handleSubmit: PT.func,
  isCreate: PT.bool,
  reset: PT.func,
  pristine: PT.bool,
  invalid: PT.bool,
  intl: PT.object,
  contact: PT.object,
};

export default injectIntl(reduxForm({
  form: 'contactForm',
  fields: ['name', 'sipUri', 'favorite'],
  validate,
  onSubmitSuccess: (values, dispatch) => {
    dispatch(actions.closeFullScreenModal());
  },
  getFormState: state => state.app.form
})(ContactForm));
